export default {
  methods: {
    pluralize(word, length) {
      if (length > 1) return `${word}s`;
      return word;
    },
  },
};
